import type { UserSearchHit } from '@citibox-panel/api-client';

// Who an account action's heading names. It has to name SOMEONE — the card that would have said
// who is covered by the modal. A pre-registration shell has no name, and the phone is what
// identifies that account everywhere else in the product.
export function accountSubject(account: Pick<UserSearchHit, 'name' | 'phone'>): string {
  const name = account.name.trim();
  return name !== '' ? name : account.phone.trim();
}
